import {useEffect} from 'react';
import PropTypes from 'prop-types';
import {get as _get} from 'lodash';

import {showModal} from '@utils/modal';
import {renderModalError} from '@utils/forms';
import useQueryCustom from '@utils/hooks/useQueryCustom';

export const TitleFromQuery = ({entity, errorBackLink, query, path, variables}) => {
    const shouldFetch = Boolean(variables?.id);
    const upperCasedTitle = entity && entity.charAt(0).toUpperCase() + entity.slice(1);
    const {data, error} = useQueryCustom({
        query: query, options: {
            variables: variables,
            fetchPolicy: 'network-only',
            skip: !shouldFetch,
        },
    });

    useEffect(() => {
        error && showModal({
            isVisible: true,
            content: renderModalError(
                upperCasedTitle,
                errorBackLink
            ),
        });
    }, [error]);

    if (!shouldFetch) {
        return `Add new ${entity}`;
    }

    const name = _get(data, path, null);

    if (!upperCasedTitle) {
        return name;
    }

    return `${upperCasedTitle}` + (name ? ` "${name}"` : '');
};

TitleFromQuery.propTypes = {
    entity: PropTypes.string.isRequired,
    errorBackLink: PropTypes.string.isRequired,
    query: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired,
    variables: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired,
};
